import React, { useState, useRef } from 'react';

export default function ContactForm() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const form = e.currentTarget;
    const formData = new FormData(form);

    // Get current date and time in IST
    const now = new Date();
    const istTime = new Date(now.getTime() + 5.5 * 60 * 60 * 1000)
      .toISOString()
      .replace('T', ' ')
      .substr(0, 19);

    try {
      // Create the URL with query parameters
      const url = new URL(
        'https://script.google.com/macros/s/AKfycbwHHjoZYH9cKu1E6z983mDK1NtnZ57GqrtJqQ-AeXW_f6fbyWD89_-ccjQe-ff9pAxF/exec'
      );

      // Add form data as query parameters
      url.searchParams.append('timestamp', istTime);
      url.searchParams.append('name', formData.get('name'));
      url.searchParams.append('email', formData.get('email'));
      url.searchParams.append('phone', formData.get('phone'));
      url.searchParams.append('message', formData.get('message'));

      // Make the request
      const response = await fetch(url.toString(), {
        method: 'GET', // Changed to GET as it's more reliable with Google Apps Script
        mode: 'no-cors',
        redirect: 'follow',
        headers: {
          Accept: 'application/json',
        },
      });

      // Wait to ensure the request completes
      await new Promise((resolve) => setTimeout(resolve, 2000));

      setStatus({
        type: 'success',
        message: 'Thanks — we received your message. We will contact you shortly.',
      });
      form.reset();
    } catch (err) {
      setStatus({
        type: 'error',
        message: 'There was a problem sending your message. Please try calling us.',
      });
    } finally {
      setLoading(false);
    }
  }

  return (
    <form onSubmit={onSubmit} className="space-y-4 max-w-xl" aria-label="Contact form">
      <div>
        <label htmlFor="name" className="block text-sm">
          Name
        </label>
        <input id="name" name="name" required className="w-full border rounded p-2" />
      </div>
      <div>
        <label htmlFor="email" className="block text-sm">
          Email
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          className="w-full border rounded p-2"
        />
      </div>
      <div>
        <label htmlFor="phone" className="block text-sm">
          Phone
        </label>
        <input id="phone" name="phone" type="tel" className="w-full border rounded p-2" />
      </div>
      <div>
        <label htmlFor="message" className="block text-sm">
          Message
        </label>
        <textarea
          id="message"
          name="message"
          rows="5"
          required
          className="w-full border rounded p-2"
        />
      </div>
      <div>
        <button
          type="submit"
          className="btn btn-wood w-full md:w-auto flex items-center justify-center gap-2"
          disabled={loading}
        >
          {loading ? (
            <>
              <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
              Sending...
            </>
          ) : (
            'Send Message'
          )}
        </button>
      </div>
      {status && (
        <div
          role="alert"
          aria-live="polite"
          className={`text-sm p-4 rounded-lg ${
            status.type === 'success' ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'
          }`}
        >
          {status.message}
        </div>
      )}
      <div aria-live="assertive" className="sr-only">
        {status && status.message}
      </div>
    </form>
  );
}
